<div class="proficiencyLegend">
  <span>
    <strong>{{ labelName }}</strong>
  </span>

  <mat-icon
    class="proficiencyLegend__helpIcon"
    role="button"
    tabindex="0"
    aria-label="Open proficiency legend"
    (click)="openProficiencyLegendDialog()"
    (keydown.enter)="openProficiencyLegendDialog()"
    (keydown.space)="openProficiencyLegendDialog()"
  >
    help
  </mat-icon>
</div>
